package br.com.vvrefeicoes.portal.domain.model

/** Abas de planilha do módulo RH, com o segmento do endpoint no backend. */
enum class RhSheetKind(
    val path: String,
) {
    CUSTOS_RH("costs"),
    ABSENTEISMO("absence"),
    MASSA_SALARIAL("payroll-mass"),
}
